export interface ApiError {
    message: string;
    error: string;
    statusCode: number;
  }
  
  
  export const handleApiError = (error: any): ApiError => {
    if (error.response && error.response.data) {
      return {
        message: error.response.data.message || 'An error occurred',
        error: error.response.data.error || 'Please try again later',
        statusCode: error.response.data.statusCode || 500
      };
    }
    return {
      message: error.message || 'An error occurred',
      error: 'Something went wrong. Please try again later.',
      statusCode: 500
    };
  };